import {
  List,
  Datagrid,
  TextField,
  EmailField,
  FunctionField,
  EditButton,
  BulkDeleteButton,
  usePermissions,
  
} from "react-admin";
import { Box, Typography } from "@mui/material";

export const UserGroupList = props => (
  <>
    <List title="User Groups" {...props}>
      
      <Box sx={{ pt: 5, pb: 5 }}>
        <Typography variant="h4" fontWeight={600} align="left">
            User Group
        </Typography>
      </Box>
      <Datagrid>
        <TextField source="id" />
        <TextField source="group_name" label="Group" />
        <TextField source="description" />
        <TextField source="users" />
         <EditButton />
      </Datagrid>
    </List>
  </>
);
